import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import NotFound from "../pages/NotFound";
import PrivateRoute from "./PrivateRoute";
import MainLayout from "../layouts/MainLayout"; // Import layout
import UserManagement from "../pages/UserManagement";
import PratinidhiManagment from "../pages/PratinidhiManagment";
import Message from "../pages/Message";
import UploadPdfs from "../pages/UploadPdfs";
import Lavajam from "../pages/Lavajam";
import HomePhoto from "../pages/HomePhoto";
import ResetPassword from "../pages/ResetPassword";
import Daan from "../pages/Daan";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <MainLayout>
              <Dashboard />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/users"
        element={
          <PrivateRoute>
            <MainLayout>
              <UserManagement />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/pratinidhis"
        element={
          <PrivateRoute>
            <MainLayout>
              <PratinidhiManagment />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/messages"
        element={
          <PrivateRoute>
            <MainLayout>
              <Message />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/pdfs"
        element={
          <PrivateRoute>
            <MainLayout>
              <UploadPdfs />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/lavajams"
        element={
          <PrivateRoute>
            <MainLayout>
              <Lavajam />
            </MainLayout>
          </PrivateRoute>
        }
      />
      
      <Route
        path="/daans"
        element={
          <PrivateRoute>
            <MainLayout>
              <Daan />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/photos"
        element={
          <PrivateRoute>
            <MainLayout>
              <HomePhoto />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/reset-password"
        element={
          <PrivateRoute>
            <MainLayout>
              <ResetPassword />
            </MainLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="*"
        element={
          <PrivateRoute>
            <MainLayout>
              <NotFound />
            </MainLayout>
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
